import {getUrlParam} from "../utilities";
import {
  SET_LANGUAGE,
  SET_NOTIFICATIONS_COUNT,
  SET_NOTIFICATIONS_RECEIVED,
  SET_NOTIFICATIONS_REQUESTED, SHOW_SUCCESS_NOTIFICATION, UPDATE_RELATED_JOBS_NOTIFICATIONS_COUNT
} from "../constants/actionTypes";
import {AVAILABLE_LANGUAGES} from "../constants/dashboard";

const urlLanguage = getUrlParam("language");
const defaultLanguage = "en-US";

let storageLanguage = "";
try {
  storageLanguage = window.localStorage.getItem("dashboard_language");
  if (!storageLanguage) {
    window.localStorage.setItem("dashboard_language", urlLanguage || defaultLanguage);
  }
} catch (ex) { console.log("localStorage exception", ex); }

const initialLanguage = urlLanguage && AVAILABLE_LANGUAGES.includes(urlLanguage)
  ? urlLanguage
  : (storageLanguage && AVAILABLE_LANGUAGES.includes(storageLanguage))
    ? storageLanguage
    : defaultLanguage;

const initialState = {
  language: initialLanguage,
  notificationsCount: 0,
  notificationsRequested: false,
  notificationsReceived: false,
  successNotification: false,
  relatedJobsNotificationsCount: 0, // update messages
};

export default function sites(state = initialState, action) {
  switch (action.type) {
    case SET_LANGUAGE: {
      // console.log('action.payload', action.payload);
      try {
        window.localStorage.setItem("dashboard_language", action.payload.language);
      } catch (ex) { console.log("localStorage exception", ex); }
      return {...state, ...action.payload};
    }
    case SET_NOTIFICATIONS_COUNT:
    case SET_NOTIFICATIONS_RECEIVED:
    case SET_NOTIFICATIONS_REQUESTED:
      return {...state, ...action.payload};
    case SHOW_SUCCESS_NOTIFICATION:
      return Object.assign({}, state, {
        ...state, successNotification: {...state.successNotification, ...action.payload}
      });
    case UPDATE_RELATED_JOBS_NOTIFICATIONS_COUNT:
      return Object.assign({}, state, {
        relatedJobsNotificationsCount: state.relatedJobsNotificationsCount + 1
      });
    default:
      return state;
  }
}
